import { render, staticRenderFns } from "./BookmarkCancel.vue?vue&type=template&id=92aa2a82&"
import script from "./BookmarkCancel.vue?vue&type=script&lang=js&"
export * from "./BookmarkCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports